import { Checkbox } from "antd";
import styled from "styled-components";

export const CheckboxGroupVertical = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    display: block;
    margin-right: 0;
}
`;
